export default __webpack_public_path__ + "static/media/Visa_Inc._logo.svg.40888662.png";